import { LitElement, html, css, unsafeCSS, nothing } from 'lit';
import styles from './select-radio-group.scss?inline';

export default class SotbitSelectRadioGroup extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        label: { type: String },
    };

    constructor() {
        super();
        this.label = '';
    }

    render() {
        return html`
            <div class="group" part="group">
                ${this.label
                    ? html`<div class="group__label" part="group-label">${this.label}</div>`
                    : nothing}
                <slot></slot>
            </div>
        `;
    }
}
